$(document).ready(function(){
    // delete confirm dialog
    $('#confirmdelete').on('show.bs.modal', function (e) {
        var modal = $('#confirmdelete');
        var $invoker = $(e.relatedTarget);
        var url = $invoker.attr('rel');
        var confirm = modal.find('#modal_commlog_confirm_delete');
        confirm.click(function(){
          window.location = url;
          // window.location.reload(true);
        });
    });
    $('#addcommlog').on('show.bs.modal', function (e) {
        console.log(e);
        if ( e.relatedTarget == undefined ) {
            return;
        }
        var modal = $('#addcommlog');
        var $invoker = $(e.relatedTarget);
        var id = $invoker.attr('rel');

        // set to blank defaults for form re-use
        modal.find('#form_modal_notes').text('');
        modal.find("#reason_id").val(0);
        modal.find("#status_id").val(0);
        modal.find("#channel_id").val(0);

        


        if( id ) {
          modal.find('form').attr('action','/participants/editcommlog/' + 0 );
          modal.find('#addedit').text('Edit');
          var json = $.get('/participants/json_commlog/' + id, function( data ) {
            var comm = JSON.parse(data);
            modal.find('form').attr('action','/participants/editcommlog/' + comm.id );
            modal.find('#form_modal_notes').text(comm.notes);
            modal.find("#reason_id").val(comm.comm_reason_id);
            modal.find("#status_id").val(comm.comm_status_id);
            modal.find("#channel_id").val(comm.channel_id);
            modal.find('[name="log_date"]').val(moment(comm.date).format('MM/DD/YYYY'));
            modal.find('[name="log_time"]').val(moment(comm.date).format('h:mma'));
          });
        } else {
          modal.find('form').attr('action','/participants/addcommlog');
          modal.find('#addedit').text('Add');
          // set computerid to currently selected value
            var json = $.get('/api/computer-id' , function( data ) {
                if ( data != '' ) {
                    modal.find("#computer_id").val(data);
                }
                

            });

            // set time and date to now
            modal.find('[name="log_date"]').val(moment().format('MM/DD/YYYY'));
            modal.find('[name="log_time"]').val(moment().format('h:mma'));
        }
    });
    
    // Edit Channel modal on Partcipant

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $('.edit_ajax').each(function(){
        var $this = $(this);
        var editForm = $this.find('form[name=edit-channel]');
        var deleteForm = $this.find('form[name=delete-confirmation]');
        var formContainer = $this.find('.edit-form-container').hide();
        var deleteConfirm = $this.find('.delete-confirm-container').hide();
        var buttonContainer = $this.find('.button-container');

        var display = $this.find('.display');
        var cancel_btn = $this.find('.cancel');
        var edit_btn = $this.find('.edit-btn');
        var deleteBtn = $this.find('.delete-btn');
        edit_btn.click(function(e){
            e.preventDefault();
            formContainer.show();
            display.hide();
            deleteConfirm.hide();
            buttonContainer.hide();

            cancel_btn.click(function(){
              e.preventDefault();
              buttonContainer.show();
              formContainer.hide();
              display.show();
            });
        });

        deleteBtn.on('click', function(e){
            e.preventDefault();
            formContainer.hide();
            display.hide();
            deleteConfirm.show();
            buttonContainer.hide();

            $this.find('.delete-cancel').click(function(){
              e.preventDefault();
              buttonContainer.show();
              deleteConfirm.hide();
              display.show();
            });
        });

        var channelTypeInput = editForm.find('select[name="channel_type_id"]');
        channelTypeInput.change(function(){
            var addressFields =  editForm.find('.address-field-container'),
            addressInput =  editForm.find('[name=address]');

            if(channelTypeInput.val() == 4 || channelTypeInput.val() == 5) {
              addressFields.show();
              addressInput.hide();
            } else {
              addressFields.hide();
              addressInput.show();
            }
        });
        channelTypeInput.trigger('change');

        deleteForm.submit(function(evt){
            evt.preventDefault();

            $.post(deleteForm.attr('action'), deleteForm.serialize(), function(obj){
              // normal usage
              var href = window.location.href.split('#')[0];
              href = href + '#editchannels';
              window.location = href;
              window.location.reload(true);
            });
        });

        editForm.submit(function(e){
            e.preventDefault();

            var url = editForm.attr('action');

            if( editForm.find('[name=channel_type_id]').val() == 4 || editForm.find('[name=channel_type_id]').val() == 5 ) {
                var addressObj = {};

                var street_1 = editForm.find('input[name=street_1]').val();
                if ( street_1 ) {
                    addressObj.street_1 = street_1;
                }
                var street_2 = editForm.find('input[name=street_2]').val();
                if ( street_2 ) {
                    addressObj.street_2 = street_2;
                }
                var city = editForm.find('input[name=city]').val();
                if ( city ) {
                    addressObj.city = city;
                }
                var state = editForm.find('select[name=state]').val();
                if ( state ) {
                    addressObj.state = state;
                }
                var zip = editForm.find('input[name=zip]').val();
                if ( zip ) {
                    addressObj.zip = zip;
                }

                editForm.find('input[name=address]').val(JSON.stringify(addressObj));
            }

            var data = editForm.serialize();
            $.post(url,data,function(obj){
                // normal usage
                var href = window.location.href.split('#')[0];
                href = href + '#editchannels';
                window.location = href;
                window.location.reload(true);
            });
        });
    });   

    $("a#addChannel").click(function(e){
      e.preventDefault();
      $('#addChannelUI').show();
      $('#addChannelUI .panel-heading').trigger('click');
      $('#addChannelUI .edit-btn').trigger('click');
      $('#addChannelUI .delete-btn').hide();
      $(this).hide();
    });

    if( window.location.hash == '#editchannels' ) {
      $('#editall').modal().show();
    }

    doSurveyAddress();

    function doSurveyAddress() {
        var edit_ajax_survey = $('.edit_ajax_survey');
        // due to the way the survey works, use a div instead of a form element
        var form = edit_ajax_survey.find('#edit_ajax_form');
        ///
        form.find('.address_edit').show();
        form.find('.text_edit').hide();
        form.find('.btn-primary').click(function(e){
            e.preventDefault();
            var string_address = [];
            var address_1 = form.find('input[name=address_1]').val();
            if ( address_1 ) {
                string_address.push(address_1);
            }
            var address_2 = form.find('input[name=address_2]').val();
            if ( address_2 ) {
                string_address.push(address_2);
            }
            var city = form.find('input[name=city]').val();
            if ( city ) {
                string_address.push(city);
            }
            var state = form.find('select[name=state]').val();
            if ( state ) {
                string_address.push(state);
            }
            var zip = form.find('input[name=zip]').val();
            if ( zip ) {
                string_address.push(zip);
            }
            string_address = string_address.join(';');
            form.find('input[name=channel_address]').val(string_address);
            var url = form.data('action');
            var data = form.find('input,select,textarea').serialize();
            $.post(url,data,function(obj){
                var pid = $('#editall').data('pid');
                var href = '/participants/gethomeaddress/' + pid;
                $.post(href,{},function(ret){
                    $("#address_well").html(ret);
                    $('#editall').modal('toggle');
                    $('.modal-backdrop').remove();
                });
            });
        });
    }
});

